import { urlToBase64, dataURLtoBlob } from "./base64Conver.js";
function downloadByData(data, filename, mime, bom) {
  const blobData = typeof bom !== "undefined" ? [bom, data] : [data];
  const blob = new Blob(blobData, { type: mime || "application/octet-stream" });
  const blobURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.href = blobURL;
  tempLink.setAttribute("download", filename);
  if (typeof tempLink.download === "undefined") {
    tempLink.setAttribute("target", "_blank");
  }
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  window.URL.revokeObjectURL(blobURL);
}
const getFilenameByResponseHeaders = (headers) => {
  if (!headers)
    return "";
  const contentDisposition = headers["content-disposition"];
  if (!contentDisposition)
    return "";
  const filenameRegex = /filename\*?=['"]?(?:[Uu][Tt][Ff]-\d['"]*)?([^;\r\n"']*)['"]?;?/;
  const matches = filenameRegex.exec(contentDisposition);
  const filename = matches ? matches[1] : "";
  return decodeURIComponent(filename) || "";
};
function downloadByUrl({ url, target = "_blank", fileName }) {
  const isChrome = window.navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
  const isSafari = window.navigator.userAgent.toLowerCase().indexOf("safari") > -1;
  if (/(iP)/g.test(window.navigator.userAgent)) {
    console.error("Your browser does not support download!");
    return false;
  }
  if (isChrome || isSafari) {
    const link = document.createElement("a");
    link.href = url;
    link.target = target;
    if (link.download !== void 0) {
      link.download = fileName || url.substring(url.lastIndexOf("/") + 1, url.length);
    }
    if (document.createEvent) {
      const e = document.createEvent("MouseEvents");
      e.initEvent("click", true, true);
      link.dispatchEvent(e);
      return true;
    }
  }
  if (url.indexOf("?") === -1) {
    url += "?download";
  }
  openWindow(url, { target });
  return true;
}
function openWindow(url, opt) {
  const { target = "_blank", noopener = true, noreferrer = true } = opt || {};
  const feature = [];
  noopener && feature.push("noopener=yes");
  noreferrer && feature.push("noreferrer=yes");
  window.open(url, target, feature.join(","));
}
function downloadByOnlineUrl(url, filename, mime, bom) {
  urlToBase64(url).then((base64) => {
    downloadByBase64(base64, filename, mime, bom);
  });
}
function downloadByBase64(buf, filename, mime, bom) {
  const base64Buf = dataURLtoBlob(buf);
  downloadByData(base64Buf, filename, mime, bom);
}
export { downloadByBase64, downloadByData, downloadByOnlineUrl, downloadByUrl, getFilenameByResponseHeaders, openWindow };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/file/download.js